import { render, staticRenderFns } from "./AddOrg.vue?vue&type=template&id=f4658ef2&"
import script from "./AddOrg.vue?vue&type=script&lang=js&"
export * from "./AddOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddOrg.vue"
export default component.exports